import { DASHBOARD_CONTAINER } from '../../../../types/types';
import { CARD_GROUP_FORM, PAYMENT_TYPE_CG, HOSE_TYPE_CG } from '../form-cardgroup-types';
import { getCustomerList } from '../form-cardgroup-helpers';
import { getParameters } from '../../../../helpers/helpers';
import { dropdown, displaySelectedValue } from '../../../dropdown';
import useAuth from '../../../../hooks/auth-hooks';

import { postNewCardGroup } from './post-new-cardgroup';

/**
 * Handles the card group form add new functionality
 * 
 * @returns void
 */
export const createNewCardGroup = () => {
  if(!CARD_GROUP_FORM.cgForm) return;

  DASHBOARD_CONTAINER.removeAttribute('style');

  const urlParam = getParameters('customerId');

  const { accessType } = useAuth()!;
  const access = accessType === 'E';

  if(urlParam) {
    CARD_GROUP_FORM.cgSearch.value = urlParam;
  }

  dropdown(PAYMENT_TYPE_CG, 'payment', 'Payment Type', false, true, access);
  dropdown(HOSE_TYPE_CG, 'hose', 'Hose Type', false, true, access);

  displaySelectedValue('.aafp_list-payment', 'payment', '1');
  displaySelectedValue('.aafp_list-hose', 'hose', '1'); 

  getCustomerList(CARD_GROUP_FORM.cgSearchButton, CARD_GROUP_FORM.cgSearch, CARD_GROUP_FORM.cgSelectedCustContainer);

  postNewCardGroup(); 
}